/* eslint no-cond-assign: 0 */
import { call, fork, put, race, take, select } from 'redux-saga/effects';

import config from '../configs/config';

import {
    ADDED_TO_CART,
    CANCEL_HIDE_CART_CONFIRM_TIMER,
    RESET_HIDE_CART_CONFIRM_TIMER,
    hideCartConfirm,
    resetAddToCart
} from '../actions/productActions';

import { delay } from '../../../core/js/utils';
import productUtils from '../utils/utils';

import { isQuickshop } from '../utils/quickshopUtils';

function *resetAddToCartAsync(ms, component) {
    yield call(delay, ms);
    yield put(resetAddToCart(component));
}

function *hideCartConfirmAsync(ms) {
    yield call(delay, ms);
    yield put(hideCartConfirm());
}

/**
 * Handles hiding the added to cart notification tray based on user interaction vs timeout
 */
export function *addedToCartSaga() {
    let action;

    while (action = yield take(ADDED_TO_CART)) {
        const component = _.get(action, 'meta.component');
        const state = yield select();

        yield fork(resetAddToCartAsync, config.addToCart.resetDelay, component);

        if (!isQuickshop(state)) {
            const enableClosenessQualifier = _.get(state, 'core.ab.SS_QUALIFIER', '') === 1;

            if (enableClosenessQualifier) {
                yield call(animateProgressBarSaga);
            }

            // race to either hide the confirmation, or cancel the hide timer due to user interaction
            yield race([
                call(hideCartConfirmAsync, config.cartConfirm.initialHideDelay),
                take(CANCEL_HIDE_CART_CONFIRM_TIMER)
            ]);
        }

        if (window.DYCS) {
            window.DYCS.discountableSubtotal = _.get(state, 'core.cart.discountableSubtotal', 0);
        }
    }
}

export function *animateProgressBarSaga() {
    const state = yield select();
    const discountableSubtotal = _.get(state, 'core.cart.discountableSubtotal', 0);
    const cartQualifierThreshold = _.get(state, 'core.constants.cartQualifierThreshold', 0);
    const qualifiedPercentage = parseInt(cartQualifierThreshold) > 0 ?
                                (discountableSubtotal * 100) / cartQualifierThreshold : 0;
    $('.js-cart-confirm-progress-bar').css('width', `${qualifiedPercentage}%`);
}

export function *resetCartConfirmTimerSaga() {
    let action;

    while (action = yield take(RESET_HIDE_CART_CONFIRM_TIMER)) {
        // race to either hide the confirmation, or cancel the hide timer due to user interaction
        yield race([
            call(hideCartConfirmAsync, config.cartConfirm.resetHideDelay),
            take(CANCEL_HIDE_CART_CONFIRM_TIMER)
        ]);
    }
}

export default [
    addedToCartSaga,
    resetCartConfirmTimerSaga
];
